import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { SECURITY_MATERIAL_LIST_API, SECURITY_MATERIAL_ADD_API, SECURITY_MATERIAL_TOGGLE_STATUS_API } from '../utils/api';
import Navbar from '../components/Navbar';

export default function SecurityMaterials() {
  const [materials, setMaterials] = useState([]);
  const [itemName, setItemName] = useState('');
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchMaterials();
  }, []);

  const fetchMaterials = async () => {
    try {
      const res = await axios.post(SECURITY_MATERIAL_LIST_API, { token, customer_id });
      if (res.data.success) {
        setMaterials(res.data.materials);
      } else {
        toast.error(res.data.message || 'Failed to load materials');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error loading materials');
    }
  };

  const handleAdd = async () => {
    if (!itemName.trim()) return toast.error('Item name is required');

    try {
      setLoading(true);
      const res = await axios.post(SECURITY_MATERIAL_ADD_API, { token, customer_id, name: itemName });
      if (res.data.success) {
        toast.success('Material added');
        setItemName('');
        fetchMaterials();
      } else {
        toast.error(res.data.message || 'Failed to add');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error adding material');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await axios.post(SECURITY_MATERIAL_TOGGLE_STATUS_API, { token, id });
      if (res.data.success) {
        toast.success('Status updated');
        fetchMaterials();
      } else {
        toast.error(res.data.message || 'Failed to update status');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error updating status');
    }
  };

  return (
    <>
        <Navbar />
    <div className="container mt-4">
      <h4 className="mb-4">🧰 Security Material List</h4>

      <div className="row g-2 mb-4">
        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Enter material/item name"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <button className="btn btn-primary" onClick={handleAdd} disabled={loading}>
            {loading ? 'Saving...' : 'Add Item'}
          </button>
        </div>
      </div>

      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Item Name</th>
            <th>Status</th>
            <th>Toggle</th>
          </tr>
        </thead>
        <tbody>
          {materials.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center text-muted">No materials found</td>
            </tr>
          )}
          {materials.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.name}</td>
              <td>
                <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-secondary'}`}>
                  {item.status === 1 ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-warning"
                  onClick={() => handleToggleStatus(item.id)}
                >
                  Toggle
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </>
  );
}
